import { IonCol, IonContent, IonGrid, IonPage, IonRow, IonText, useIonViewDidEnter } from "@ionic/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { OptionPages } from '../../models/apiModels'
import { translation } from "../../models/translation";
import { fetchOptions } from "../../services/options_service";
import LanguagePack from "../../services/translations";
interface LegalNotProps{
    user?:any
}
const LegalNotice: React.FC<LegalNotProps> = (props) => {
  

    const siteText=translation();
    const pathName = useLocation().pathname;

    const isAccountPage = () => {
      if (pathName.indexOf('account') < 0) return false;
      return true
    }
    const [siteOptions, setSiteOptions] = useState<OptionPages>();

    const getOptions = async () => {
        let resp: any = await fetchOptions();
        if (!resp.error) {
            let options: OptionPages = resp.message;
            setSiteOptions(options);
        }
    }
    useEffect(() => {
        getOptions()
    }, []);

    return (
        <IonPage className="pageContent">
            <IonContent>
                <IonGrid className={!isAccountPage()?'sw_sp_md':''}>
                    <IonRow>
                        <IonCol offsetSm="1"  sizeSm="10">
                        <IonRow>
                        <IonCol>
                            <IonText>
                                <h1>{siteText.footLnkImpressTxt}</h1>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        {siteOptions?<IonCol>
                            {siteText.lan==="/fr" && <div  dangerouslySetInnerHTML={{ __html: siteOptions?.acf.legalnotice_fr! }}></div>}
                            {siteText.lan==="/en" && <div  dangerouslySetInnerHTML={{ __html: siteOptions?.acf.legalnotice_en! }}></div>}
                            {siteText.lan==="/de" && <div  dangerouslySetInnerHTML={{ __html: siteOptions?.acf.legalnotice_de! }}></div>}
                        </IonCol>:''}
                    </IonRow>
                        </IonCol>
                    </IonRow>
                    
                </IonGrid>
            <Footer></Footer>
            </IonContent>
        </IonPage>)
}

export default LegalNotice;

